import axios from 'axios';
import Cookies from 'universal-cookie';
import constants from './constants.js';
const jwtDecode = require('jwt-decode');

/*
 global window
 */

const cookies = new Cookies();
const client = (() => {
    const hostname = window.location.hostname;
    return axios.create({
        baseURL: constants.api[hostname] || constants.api.url,
    });
})();

const checkTokenExpiration = () => {
    if (typeof cookies.get('token') !== 'undefined') {
        var decoded = jwtDecode(cookies.get('token'));
        if (decoded.exp < parseInt(Date.now() / 1000, 10)) {
            return true;
        }
        return false;
    }
    return true;
};

const request = function(options) {
    const onSuccess = function(response) {
        return response.data;
    };

    const onError = function(error) {
        return Promise.reject(error.response || error.message);
    };

    options.headers = {
        Authorization: 'Bearer ' + cookies.get('token'),
    };

    return client(options)
        .then(onSuccess)
        .catch(onError);
};

client.interceptors.request.use(
    config => {
        if (
            !/register/.test(config.url) &&
            !/language/.test(config.url) &&
            !/validate-payment/.test(config.url) &&
            !/token-signin/.test(config.url) &&
            !/version/.test(config.url) &&
            !/config/.test(config.url) &&
            !/cities/.test(config.url)
        ) {
            if (checkTokenExpiration()) {
                setTimeout(() => {
                    alert('No token !');
                }, 10);
                window.location = '/register';
            } else {
                return config;
            }
        } else {
            return config;
        }
    },
    error => {
        return Promise.reject(error);
    }
);
client.interceptors.response.use(
    config => {
        return config;
    },
    err => {
        if (err.response && err.response.status === 401 && checkTokenExpiration()) {
            let originalRequest = err.config;
            if (/auth/.test(originalRequest.url)) {
                return Promise.reject(err);
            }
            originalRequest._retry = true;

            return requestToken(originalRequest);
        }

        return Promise.reject(err);
    }
);

const requestToken = originalRequest => {
    return client({
        url: '/auth/token',
        method: 'POST',
        data: {
            token: originalRequest.headers['Authorization'],
            refresh_token: cookies.get('refresh_token'),
        },
    })
        .then(resp => {
            cookies.set('token', resp.data.token, { path: '/' });
            originalRequest.headers['Authorization'] = 'Bearer ' + resp.data.token;
            return client(originalRequest);
        })
        .catch(err => {
            console.log('ERR', err);
        });
};

export default request;
